import { Injectable } from '@angular/core';
import { BehaviorSubject,  map,  Observable, of, shareReplay } from 'rxjs';
import { StudentCounsellingReportService } from './student-counselling-report.service';

@Injectable({
  providedIn: 'root'
})
export class DialogdataService {

  private stateCache$ = new BehaviorSubject<any[] | null>(null);
  private cityCache$ = new BehaviorSubject<any[] | null>(null);
  private campusCache$ = new BehaviorSubject<any[] | null>(null);
  private counsellorCache$ = new BehaviorSubject<any[] | null>(null);
  private reasonsCache$ = new BehaviorSubject<any[] | null>(null)
  private categoryDetailsCache$ = new BehaviorSubject<any[] | null>(null);
  private lastCategoryParams: any = {};
  private lastStateId: number | null = null;
private lastCityId: number | null = null;
private lastCampusId: number | null = null;
private lastCounsellorCampusId: number | null = null;
private lastReasonId: number | null = null;;
private lastParamsKey: string | null = null;
  private issuesCache$ = new BehaviorSubject<any[] | null>(null);

  constructor(private verification: StudentCounsellingReportService) {}

  clearReasonsCache() {
    this.reasonsCache$.next(null);
  }
  private isEmpty(value: any[] | null): boolean {
    return !value || value.length === 0;
  }

getStates(): Observable<any[] | null> {
  if (!this.stateCache$.value) {
    this.verification.getstate().subscribe((res: any) => this.stateCache$.next(res));
  }
  return this.stateCache$.asObservable();
}
getCity(stateId: number): Observable<any[] | null> {
  if (!this.cityCache$.value || this.lastStateId !== stateId) {
    this.lastStateId = stateId;
    this.verification.getcity(stateId).subscribe((res: any) => this.cityCache$.next(res));
  }
  return this.cityCache$.asObservable();
}
getCampus(cityId: number): Observable<any[] | null> {
  if (!this.campusCache$.value || this.lastCityId !== cityId) {
    this.lastCityId = cityId;
    this.verification.getcampus(cityId).subscribe((res: any) => this.campusCache$.next(res));
  }
  return this.campusCache$.asObservable();
}
getCounsellors(campusId: number): Observable<any[] | null> {
  if (!this.counsellorCache$.value || this.lastCampusId !== campusId) {
    this.lastCounsellorCampusId = campusId;
    this.verification.getcounseller(campusId).subscribe((res: any) => this.counsellorCache$.next(res));
  }
  return this.counsellorCache$.asObservable();
}
getReasons(): Observable<any[] | null> {
  const res = this.reasonsCache$.value;
  if (this.isEmpty(res)) {
    this.verification.getreasons().subscribe((data: any) => this.reasonsCache$.next(data));
  }
  return this.reasonsCache$.asObservable();
}
getIssues(reasonId: number): Observable<any[] | null> {
  if (!this.issuesCache$.value || this.lastReasonId !== reasonId) {
    this.lastReasonId = reasonId;
    this.verification.getidentifiyiuess(reasonId).subscribe((res: any) => this.issuesCache$.next(res));
  }
  return this.issuesCache$.asObservable();
}
getCategoryDetails(params: {
  academicYear: string;
  cityId: number;
  campusId?: number;
  counsellorId?: number;
}): Observable<any[]> {
  // Always make fresh call
  return this.verification.getCategoryDetails(params).pipe(
    map(res => res?.categoryDetails || []),
    shareReplay({ bufferSize: 1, refCount: true }) // Avoid duplicate calls if subscribed multiple times
  );
}
clearCategoryCache() {
  this.categoryDetailsCache$.next(null);
}

// You can also have similar caching methods for state, city, campus, etc. here


  clearAll() {
    this.stateCache$.next(null);
    this.cityCache$.next(null);
    this.campusCache$.next(null);
    this.counsellorCache$.next(null);
    this.reasonsCache$.next(null);
    this.issuesCache$.next(null);
  }

}
